const CONFIG = {
    devMode: false,        // set to true to bypass location and desktop checks
    devLocation: false,    // set to true to bypass location check on desktop
    demo: false,           // set to true to use the demo API endpoint

    apiUrl: (false || false || false)
      ? 'http://hc.bookmy.project8.inscribecms.com/slb-app/api.php'
      : 'https://app.app-clip.smartlockbooking.com.au/slb-app/api.php',
  };
  //https://app.app-clip.smartlockbooking.com.au/slb-app/api.php
  export { CONFIG };
  